import { lazy } from 'react';

const Test = lazy(() => import('../pages/protected/Test'));

const Dashboard = lazy(() => import('../pages/protected/dashboard/Dashboard'));
const ChangePassword = lazy(() => import('../pages/protected/setting/ChangePassword'));
const SettingTab = lazy(() => import('../pages/protected/setting/SettingTab'));
const Profile = lazy(() => import('../pages/protected/setting/Profile'));
const ThemeColorSelection = lazy(() => import('../theme/ThemeColorSelection'));

const Customer = lazy(() => import('../pages/protected/customer/Customer'));
const Category = lazy(() => import('../pages/protected/category/Category'));
const Product = lazy(() => import('../pages/protected/product/Product'));
const Orders = lazy(() => import('../pages/protected/orders/Orders'));

export const ProtectedRouteList = [
  { path: 'dashboard', element: <Dashboard /> },
  { path: 'test', element: <Test /> },
  // { path: 'jobs', element: <JobTabs /> },
  { path: 'profile', element: <Profile /> },
  { path: 'theme', element: <ThemeColorSelection /> },
  { path: 'settings', element: <SettingTab /> },
  { path: 'change-password', element: <ChangePassword /> },

  { path: 'customer', element: <Customer /> },
  { path: 'category', element: <Category /> },
  { path: 'product', element: <Product /> },
  { path: 'orders', element: <Orders /> },
];
